export const fechaComun = (fecha) => {
  let fechaTemp = new Date(fecha)
  fechaTemp.setDate(fechaTemp.getDate() + 1)
  fechaTemp.setHours(0, 0, 0, 0)
  fechaTemp.setHours(0, 0, 0, 0)
  return fechaTemp
}

export const obtenerNombreMes = (numeroMes) => {
  const opciones = { month: 'long' }
  return new Intl.DateTimeFormat('es-ES', opciones).format(new Date(2021, numeroMes - 1))
}

export const formatearHora = (hora) => {
  if (!hora) {
    return ''
  }
  // Convertir el tiempo a un objeto Date
  const date = new Date(`1970-01-01T${hora}Z`) // '1970-01-01' es una fecha ficticia para crear el objeto Date

  // Extraer las horas, minutos y segundos con formato 2 dígitos
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')
  const seconds = date.getUTCSeconds().toString().padStart(2, '0')

  // Formatear a HH:mm:ss
  return `${hours}:${minutes}:${seconds}`
}

export const formatearFechaCreatedAt = (fechaHora) => {
  const fecha = new Date(fechaHora)
  const dia = String(fecha.getDate()).padStart(2, '0') // Agrega un 0 a los días menores a 10
  const mes = String(fecha.getMonth() + 1).padStart(2, '0') // Los meses empiezan en 0
  const anio = fecha.getFullYear()
  return `${dia}/${mes}/${anio}`
}

export const formatearHoraCreatedAt = (fechaHora) => {
  const fecha = new Date(fechaHora)
  const hora = String(fecha.getHours()).padStart(2, '0')
  const minutos = String(fecha.getMinutes()).padStart(2, '0')
  return `${hora}:${minutos}`
}

export const anioActual = () => {
  const fecha = new Date()
  const anio = fecha.getFullYear()
  return anio
}

export const aniosCombo = () => {
  const anio = new Date().getFullYear()
  // return [anio, anio - 1, anio - 2, anio - 3]
  return [anio, anio - 1]
}
